import React from "react";
import "./about.css";
import ME from "../../assets/me-about3.jpg";
import ME2 from "../../assets/me15.JPG";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5 className="text-light">Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME2} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <div className="about__card-content">
                <p>4+ Years Working</p>
                <p className="highlight">US Citizen</p>
              </div>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Education</h5>
              <div className="about__card-content">
                <p>B.S. Business Administration, Information Technology Management</p>
                <p className="highlight">Georgia Tech</p>
                <p>M.S. Computer Science, Artificial Intelligence</p>
                <p className="highlight">Georgia Tech</p>
              </div>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <div className="about__card-content">
                <p>10+ Completed</p>
                <p className="highlight">Various Domains</p>
              </div>
            </article>
          </div>

          <div className="about__description">
            <p>
              Leading the charge in tech at Optimed Health as a Software Engineer, while diving into the world of AI
              through Georgia Tech’s top-tier M.S. in Computer Science. My journey started with a dual degree in
              Business Administration and Computer Science at Georgia Tech — a combo that gave me both sharp technical
              skills and a solid business edge.
            </p>
            <p>
              I operate at the crossroads of strategy and innovation, where clear thinking meets cutting-edge tech. With
              a mix of clean code, smart data analysis, and strong communication, I take complex problems and craft
              real, impactful solutions.
            </p>
          </div>

          <a href="#contact" className="btn btn-primary">
            Let's Connect
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
